import './MultipleChoice.scoped.scss'
import Radio from 'Shared/components/Radio'
import useQuestionTranslate from 'FlowBuilder/hooks/useQuestionTranslate';

export default function OptInRadio({ response, setResponse, name, disabled = false, className = '', question = {} }) {
  const handleChange = (event) => {
    if(event.target.checked){
      setResponse(event.target.value);
    }
  }

  const { fallback: { yesLabel: yesTranslated, noLabel: noTranslated } } = useQuestionTranslate({ questionOverride: question })

  const yesLabel = yesTranslated || 'Yes'
  const noLabel = noTranslated || 'No'

  return (
    <div className={`answers ${className}`}>
      <Radio
        value='y'
        onChange={handleChange}
        disabled={disabled}
        checked={response === 'y'}
        label={yesLabel}
        key='y'
      />
      <Radio
        value='n'
        onChange={handleChange}
        disabled={disabled}
        checked={response === 'n'}
        label={noLabel}
        key='n'
      />
    </div>
  )
}
